import {
  buildGlobalStylesheet,
  getColorsCssVarsObject,
  getVariablesCssVarsObject,
} from '@loomhq/lens';
/**
 * !! this file is imported in every bundle !!
 */
import cssVars from 'css-vars-ponyfill';

cssVars({
  variables: { ...getColorsCssVarsObject(), ...getVariablesCssVarsObject() },
});

const style = document.createElement('style');

style.innerHTML = buildGlobalStylesheet();
document.head.appendChild(style);

window.donut = () => {
  console.log(`
    🍩
    🍩 🍩🍩🍩 🍩🍩🍩 🍩🍩🍩🍩
    🍩 🍩   🍩🍩   🍩 🍩 🍩 🍩
    🍩 🍩🍩🍩 🍩🍩🍩 🍩 🍩 🍩
  `);
};
